var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "groupBox", style: _vm.boxPadding }, [
        _c("div", { staticClass: "group", style: _vm.boxStyle }, [
          _c(
            "div",
            {
              staticClass: "group-top acea-row row-middle row-between",
              style: _vm.selectBgImg == 0 ? _vm.bgImgStyle : _vm.headerBgStyle,
            },
            [
              _c("div", { staticClass: "group-top-left acea-row" }, [
                _vm.selectStyle == 0
                  ? _c("img", {
                      staticClass: "group_logo",
                      attrs: { src: _vm.logoUrl, alt: "" },
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "titleFont",
                        style: _vm.headerTitleConfig,
                      },
                      [_vm._v(_vm._s(_vm.titleConfig))]
                    ),
                _c("div", { staticClass: "interval", style: _vm.lineColor }),
                _c("img", {
                  staticClass: "pinkHead",
                  style: _vm.contentStyle,
                  attrs: {
                    src: require("@/assets/imgs/pinkHead.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "num", style: _vm.titleColor }, [
                  _vm._v("134人拼团成功"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "group-top-right", style: _vm.headerBtnColor },
                [
                  _vm._v(" 更多 "),
                  _c("i", { staticClass: "el-icon-arrow-right" }),
                ]
              ),
            ]
          ),
          _vm.listStyle == 0
            ? _c(
                "div",
                { staticClass: "group-bottom", style: _vm.boxBgStyle },
                _vm._l(2, function (item, index) {
                  return _c(
                    "div",
                    { key: index, style: index > 0 ? _vm.contentConfig : {} },
                    [
                      _c("div", { staticClass: "acea-row row-between" }, [
                        _c("div", { staticClass: "group-bottom-left" }, [
                          _c(
                            "div",
                            {
                              staticClass: "img acea-row row-center row-middle",
                              style: _vm.contentStyle,
                            },
                            [
                              _c("img", {
                                staticClass: "shan",
                                attrs: {
                                  src: require("@/assets/imgs/shan.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "group-bottom-right acea-row row-column row-between",
                          },
                          [
                            _c("div", { staticClass: "right-top" }, [
                              _vm.typeShow.includes(0)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "title line2",
                                      style: _vm.nameColor,
                                    },
                                    [
                                      _vm._v(
                                        " THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.typeShow.includes(1)
                                ? _c("div", { staticClass: "pink acea-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "people-box acea-row",
                                        style: _vm.groupTitleColor,
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "people",
                                            style: _vm.groupTitleColor,
                                          },
                                          [_vm._v("2人团")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "groupNum",
                                            style: _vm.groupTitleFontColor,
                                          },
                                          [_vm._v("已拼3份")]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "right-bottom acea-row row-between",
                              },
                              [
                                _c("div", { staticClass: "price" }, [
                                  _vm.typeShow.includes(2)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "pinkNum",
                                          style: _vm.priceColor,
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "pinkNum-title" },
                                            [_vm._v("拼团价")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "pinkNum-icon" },
                                            [_vm._v("￥")]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "pinkNum-num semiBold",
                                            },
                                            [_vm._v("3200.00")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.typeShow.includes(3)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "num",
                                          style: _vm.originalColor,
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "num-title" },
                                            [_vm._v("单买价")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "num-icon" },
                                            [_vm._v("￥")]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "icon-num semiBold",
                                            },
                                            [_vm._v("4233.00")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm.groupBtnShow
                                  ? _c("div", { staticClass: "btnBox" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btn",
                                          style: _vm.btnColor,
                                        },
                                        [_vm._v("去拼团")]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.listStyle == 1
            ? _c(
                "div",
                {
                  staticClass:
                    "group-bottom two acea-row row-between grid-list",
                  style: _vm.boxBgStyle,
                },
                _vm._l(4, function (item, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "group-bottom-left" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "img acea-row row-center row-middle big-img",
                          style: _vm.contentStyle,
                        },
                        [
                          _c("img", {
                            staticClass: "shan",
                            attrs: {
                              src: require("@/assets/imgs/shan.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "two-item" }, [
                      _c("div", { staticClass: "title acea-row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "numPink-box",
                            style: _vm.groupTitleColor,
                          },
                          [
                            _vm.typeShow.includes(1)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "numPink",
                                    style: _vm.groupTitleFontColor,
                                  },
                                  [_vm._v("5人团")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm.typeShow.includes(0)
                          ? _c(
                              "span",
                              {
                                staticClass: "line1",
                                class: _vm.typeShow.includes(1)
                                  ? "line1-show"
                                  : "line1-hidden",
                                style: _vm.nameColor,
                              },
                              [
                                _vm._v(
                                  "THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        { staticClass: "two-item-bottom acea-row row-between" },
                        [
                          _c("div", { staticClass: "price" }, [
                            _vm.typeShow.includes(2)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "pinkNum",
                                    style: _vm.priceColor,
                                  },
                                  [
                                    _c("span", [_vm._v("￥")]),
                                    _c(
                                      "span",
                                      { staticClass: "num semiBold" },
                                      [_vm._v("3200.00")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.typeShow.includes(3)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "otNum",
                                    style: _vm.originalColor,
                                  },
                                  [
                                    _c("span", [_vm._v("￥")]),
                                    _c("span", { staticClass: "semiBold" }, [
                                      _vm._v("3699.00"),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm.groupBtnShow
                            ? _c("div", { staticClass: "btnBox" }, [
                                _c(
                                  "div",
                                  { staticClass: "btn", style: _vm.btnColor },
                                  [_vm._v("去拼团")]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm.listStyle == 2
            ? _c(
                "div",
                {
                  staticClass: "group-bottom three acea-row grid-three",
                  style: _vm.boxBgStyle,
                },
                _vm._l(6, function (item, index) {
                  return _c("div", { key: index, staticClass: "three-box" }, [
                    _c("div", { staticClass: "group-bottom-left" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "img acea-row row-center row-middle three-img",
                          style: _vm.contentStyle,
                        },
                        [
                          _c("img", {
                            staticClass: "shan",
                            attrs: {
                              src: require("@/assets/imgs/shan.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "two-item" }, [
                      _c("div", { staticClass: "title acea-row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "numPink-box numPink-box-special",
                            style: _vm.groupTitleColor,
                          },
                          [
                            _vm.typeShow.includes(1)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "numPink",
                                    style: _vm.groupTitleFontColor,
                                  },
                                  [_vm._v("5人团")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm.typeShow.includes(0)
                          ? _c(
                              "span",
                              { staticClass: "line1", style: _vm.nameColor },
                              [
                                _vm._v(
                                  "THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "two-item-bottom" }, [
                        _c("div", { staticClass: "price" }, [
                          _vm.typeShow.includes(2)
                            ? _c(
                                "div",
                                {
                                  staticClass: "pinkNum",
                                  style: _vm.priceColor,
                                },
                                [
                                  _c("span", [_vm._v("￥")]),
                                  _c("span", { staticClass: "num semiBold" }, [
                                    _vm._v("3200.00"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.typeShow.includes(3)
                            ? _c(
                                "div",
                                {
                                  staticClass: "otNum",
                                  style: _vm.originalColor,
                                },
                                [
                                  _c("span", [_vm._v("￥")]),
                                  _c("span", { staticClass: "semiBold" }, [
                                    _vm._v("3699.00"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm.listStyle == 3
            ? _c(
                "div",
                {
                  staticClass: "group-bottom four acea-row",
                  style: _vm.boxBgStyle,
                },
                _vm._l(6, function (item, index) {
                  return _c("div", { key: index, staticClass: "four-item" }, [
                    _c("div", { staticClass: "group-bottom-left" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "img acea-row row-center row-middle four-img",
                          style: _vm.contentStyle,
                        },
                        [
                          _c("img", {
                            staticClass: "shan",
                            attrs: {
                              src: require("@/assets/imgs/shan.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "two-item" }, [
                      _c(
                        "div",
                        { staticClass: "title acea-row", style: _vm.nameColor },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "numPink-box numPink-box-special",
                              style: _vm.groupTitleColor,
                            },
                            [
                              _vm.typeShow.includes(1)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "numPink",
                                      style: _vm.groupTitleFontColor,
                                    },
                                    [_vm._v("5人团")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm.typeShow.includes(0)
                            ? _c("span", { staticClass: "line1" }, [
                                _vm._v(
                                  "THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c("div", { staticClass: "two-item-bottom" }, [
                        _c("div", { staticClass: "price" }, [
                          _vm.typeShow.includes(2)
                            ? _c(
                                "div",
                                {
                                  staticClass: "pinkNum",
                                  style: _vm.priceColor,
                                },
                                [
                                  _c("span", [_vm._v("￥")]),
                                  _c("span", { staticClass: "num semiBold" }, [
                                    _vm._v("3200.00"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.typeShow.includes(3)
                            ? _c(
                                "div",
                                {
                                  staticClass: "otNum",
                                  style: _vm.originalColor,
                                },
                                [
                                  _c("span", [_vm._v("￥")]),
                                  _c("span", { staticClass: "semiBold" }, [
                                    _vm._v("3699.00"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }